export default __webpack_public_path__ + "static/media/no-image-available.a5bb057a.svg";